"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InterleavedConnector = void 0;
const a_interleaved_connector_1 = require("./a-interleaved-connector");
/**
 * @public
 * {@inheritDoc IInterleavedConnector}
 */
class InterleavedConnector extends a_interleaved_connector_1.AInterleavedConnector {
    constructor(data, config) {
        super(config, data.length, data.BYTES_PER_ELEMENT);
        this.data = data;
    }
    getData() {
        return this.data;
    }
}
exports.InterleavedConnector = InterleavedConnector;
//# sourceMappingURL=interleaved-connector.js.map